// ** Custom Components
import SectionHero from "./SectionHero"
import SectionCTA from "./SectionCTA"
import SectionContent from "./SectionContent"
import SectionList from "./SectionList"
import { Fragment } from "react"
import { classNames } from "../../utils/helpers"
import Container from "../Container"

const sectionComponents: any = {
  SectionHero,
  SectionCta: SectionCTA,
  SectionContent,
  SectionList,
}

interface ContentSectionsProps {
  sections: any
}
let isPairLeft: boolean
let isPairRight: boolean
let sectionPair: any[] = []

const ContentSections = ({ sections }: ContentSectionsProps) =>
  sections?.map((section: any, index: number) => {
    if (section && section.__typename) {
      const component = section.__typename.replace("Sanity", "")
      const rounded = section?.tags?.includes("rounded")
      const isPair = section?.tags?.includes("pair")
      if (sectionPair.length === 2) sectionPair = []
      if (isPair) {
        isPairLeft = section?.tags?.includes("pair-left")
        isPairRight = section?.tags?.includes("pair-right")
        if (isPairLeft)
          sectionPair = [
            sectionComponents[component]({
              section,
            }),
            ...sectionPair,
          ]
        if (isPairRight) {
          sectionPair = [
            ...sectionPair,
            sectionComponents[component]({
              section,
            }),
          ]
        }
      }
      return (
        <Fragment key={"sections" + index}>
          {!isPair &&
            sectionComponents[component]({
              section,
            })}
          {isPair && sectionPair.length === 2 && (
            <Container
              fullWidthOnMobile={false}
              constrainedToBreakPoint
              className="w-full"
            >
              <div
                className={classNames(
                  "w-full flex flex-col lg:flex-row",
                  rounded &&
                    "rounded-[20px] overflow-hidden isolate !shadow-md text-center"
                )}
              >
                <div className={classNames("w-full lg:w-1/2")}>
                  {sectionPair && sectionPair[0]}
                </div>
                <div className={classNames("w-full lg:w-1/2")}>
                  {sectionPair && sectionPair[1]}
                </div>
              </div>
            </Container>
          )}
        </Fragment>
      )
    }
    return null
  })

export default ContentSections
